export default __webpack_public_path__ + "static/media/frame_card_bg.82a95451.png";